/* tslint:disable */
/* eslint-disable */
/**
 * RZPV API
 * API rozklikávacího rozpočtu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {baseAxios} from '@mc/axios-api';
import * as Api from './api';

export * from './configuration';
export * from './model';

let baseURL = '';

const StromApi = new Api.StromControllerApi(undefined, baseURL, baseAxios);
const SouhrnApi = new Api.SouhrnControllerApi(undefined, baseURL, baseAxios);
const StatistikaApi = new Api.StatistikaControllerApi(undefined, baseURL, baseAxios);
const SettingsApi = new Api.SettingsControllerApi(undefined, baseURL, baseAxios);
const FulltextApi = new Api.FulltextControllerApi(undefined, baseURL, baseAxios);

export {StromApi, SouhrnApi, StatistikaApi, SettingsApi, FulltextApi, baseURL};
